import { defineStore } from 'pinia'

export const useAppointmentStore = defineStore('appointment', {
    state: () => ({
        modal_appointment: {},
        next_appointment: {},
        appointment: {},
        prescription_appointment: {},
        note: '',
        show_note: false,
    }),
    getters: {
        hasNote: (state) => state.show_note && state.note.length,
        inAppointment: state => state.appointment && state.appointment.id,
    },
    actions: {
        setAppointment(appointment) {
            this.appointment = appointment;
        },
        setNextAppointment(next_appointment) {
            this.next_appointment = next_appointment;
        },
        setModalAppointment(modal_appointment) {
            this.modal_appointment = modal_appointment;
        },
        setPrescriptionAppointment(prescription_appointment) {
            this.prescription_appointment = prescription_appointment;
        },
    },
})